import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Grid,
  Button,
  Paper,
  Divider,
  TextField,
  useMediaQuery,
  Stack,
  Avatar,
  useTheme,
  Snackbar,
  Alert,
} from "@mui/material";
import { useSelector } from "react-redux";
import { CheckCircle, Cancel, Business } from "@mui/icons-material";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import {
  ORDER_API_12,
  Approveorder_API_01,
  ORDER_API_13,
} from "../../api/ApiModel";
import {
  CON_STATUS_PENDING,
  CON_STATUS_NO,
  CON_IS_CASHIER_YES,
  CON_STATUS_RECEIVED,
  CON_STATUS_ACTIVE,
} from "../../utils/sys/Constants";
import currencyFormat from "../../../src/utils/common/CurrencyFormat";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import WorkIcon from "@mui/icons-material/Work";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useStyles } from "../../assets/styles/Theme";

import { BASEURL, FILESERVERURL } from "../../config/Config";
import { useLocation } from "react-router-dom";

function RemoteApprovals() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const isMobile = useMediaQuery("(max-width:600px)");
  const [approvalData, setApprovalData] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const param = atob(queryParams.get("OC")) || "";
  const orderCode = param.split("|")[0] || "";
  const enuser = param.split("|")[1] || "";
  console.log("orderCode", orderCode);
  console.log("enuser", enuser);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isApproved, setIsApproved] = useState(false); // to conditionally show success content

  useEffect(() => {
    fetchApprovalOrders();
  }, [orderCode]);

  const fetchApprovalOrders = async () => {
    if (!orderCode) return;
    try {
      const response = await externalgetApi(ORDER_API_12, "GET", {
        ORDERCODE: orderCode, //8132
        ISCASHIER: CON_IS_CASHIER_YES,
        STS: CON_STATUS_ACTIVE,
        STSP: CON_STATUS_PENDING,
        STSN: CON_STATUS_NO,
        STSR: CON_STATUS_RECEIVED,
      });

      const invoiceDetails = response["1"]?.[0] || {};
      const orderItems = response["2"] || [];
       const AgentExpensedet = response["4"] || [];

      setApprovalData({
        ...invoiceDetails,
        orderItems,
        AgentExpensedet,
      });

      console.log("response orderrrrp ppppp", response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async () => {
    const payload = {
      ordercode: orderCode || "",
      remark: "Approved via app",
      approvedate: new Date().toISOString().slice(0, 10),
      // approvedate: new Date().toISOString(),

      sts: CON_STATUS_ACTIVE,
      enuser: enuser,
    };

    try {
      const response = await externalpostApi(ORDER_API_13, payload);

      setSuccessMessage("Order approved successfully!");
      // setSnackbarOpen(true);
      setIsApproved(true);
      console.log("Response from server:", response);
    } catch (error) {
      setSuccessMessage("Approval failed: " + error.message);
      setSnackbarOpen(true);
      console.error("Error:", error);
    }
  };

  const agentFee = parseFloat(approvalData?.AGENTFEE || 0);
  const agentExpenses = parseFloat(approvalData?.AGENTEXPENSES || 0);
  const totalAmount = agentFee - agentExpenses;

  const invoiceDetails = [
    { label: "Invoice No.:", value: approvalData?.INVNO || "N/A" },
    { label: "Submitted By:", value: approvalData?.ENUSER || "N/A" },
    {
      label: "Submitted Date:",
      value: approvalData?.ORDERENDATE
  ? new Date(approvalData.ORDERENDATE).toISOString().split('T')[0]
  : "N/A",


    },
   {
  label: "Submitted Time:",
  value: approvalData?.ORDERTIME
    ? approvalData.ORDERTIME.split('.')[0] // strips milliseconds: "11:54:14"
    : "N/A",
},

    { label: "Guest Name:", value: approvalData?.GUESTREFCODE || "N/A" },
  ];

  const agentDetails = [
    { label: "Agent Name:", value: approvalData?.AGENTNAME || "N/A" },
    {
      label: "Agent Fee:",
      value: currencyFormat(approvalData?.AGENTFEE || "N/A"),
    },
    // {
    //   label: "Agent Expenses:",
    //   value: currencyFormat(approvalData?.AGENTEXPENSES || "N/A"),
    // },
  ];

    const agentExp = [
    // { label: "Agent Name:", value: approvalData?.AGENTNAME || "N/A" },
    // {
    //   label: "Agent Fee:",
    //   value: currencyFormat(approvalData?.AGENTFEE || "N/A"),
    // },
    {
      label: "Total Expenses:",
      value: currencyFormat(approvalData?.AGENTEXPENSES || "N/A"),
    },
  ];

  const billingDetails = [
    {
      label: "Payable Amount",
      value: currencyFormat(totalAmount || "N/A"),
    },
    {
      label: "Order Total",
      value: currencyFormat(approvalData?.AMOUNT || "N/A"),
    },
    {
      label: "Final Bill Amount",
      value: currencyFormat(approvalData?.AMOUNT || "N/A"),
    },
  ];

  const logoUrl = FILESERVERURL + approvalData?.IMGPATH?.replace(/^\/+/, "");

  useEffect(() => {
    // Push a dummy state to prevent initial back navigation
    window.history.pushState(null, "", window.location.href);

    const handleBack = (e) => {
      e.preventDefault();
      // Push again to prevent back navigation
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);

  return (
    <>
      {/* ✅ Top Navigation Bar */}
      <AppBar position="fixed" sx={{ backgroundColor: "#2c586e" }}>
        <Toolbar>
          <Avatar
            sx={{ mr: 1, bgcolor: "transparent" }}
            variant="rounded"
            src={logoUrl}
            alt="Restaurant Logo"
          />
          <Typography variant="h6" noWrap>
            {approvalData?.RESTNAME || "N/A"}
          </Typography>
        </Toolbar>
      </AppBar>

      {/* ✅ Main Content */}

      {approvalData?.AGENTSTS === "A" ? (
        <Paper
          elevation={5}
          sx={{
            p: 4,
            maxWidth: 460,
            margin: "auto",
            textAlign: "center",
            height: "100vh",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <CheckCircle sx={{ fontSize: 60, color: "#00C851", mb: 2 }} />
          <Typography variant="h5" fontWeight="bold">
            This order is already approved
          </Typography>
          <Typography sx={{ mt: 1, color: "#555" }}>
            No further action is required.
          </Typography>
        </Paper>
      ) : isApproved ? (
        <Paper
          elevation={5}
          sx={{
            p: 4,
            maxWidth: 460,
            margin: "auto",
            textAlign: "center",
            height: "100vh",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <CheckCircle sx={{ fontSize: 60, color: "#00C851", mb: 2 }} />
          <Typography variant="h5" fontWeight="bold">
            Order Approved Successfully!
          </Typography>
          <Typography sx={{ mt: 1, color: "#555" }}>
            Thank you. This invoice has been processed.
          </Typography>
        </Paper>
      ) : (
        <Paper
          elevation={5}
          sx={{
            p: 4,
            borderRadius: 0,
            background: "linear-gradient(145deg, #ffffff, #f0f0f3)",
            boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
            maxWidth: 460,
            margin: "auto",
            color: "#1F1D2B",
            mt: 5,
          }}
        >
          <Typography
            variant="h5"
            sx={{ color: "#1F1D2B", fontWeight: 600, mb: 1 }}
          >
            Invoice Approval
          </Typography>
          <Typography variant="subtitle1" sx={{ color: "#5C5C5C", mb: 3 }}>
            Please review the following request before proceeding.
          </Typography>

          {/* === Section: Invoice Details === */}
          <Typography variant="h6" sx={styles.remo_title_text}>
            <ReceiptIcon sx={{ color: "#5C5C5C" }} /> Invoice Details
          </Typography>
          <Divider sx={{ mb: 2, background: "#ABBBC2" }} />

          <Grid container spacing={2}>
            {invoiceDetails.map((detail, idx) => (
              <React.Fragment key={idx}>
                <Grid item xs={6}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 500, color: "#5C5C5C" }}
                  >
                    {detail.label}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 600, textAlign: "right" }}
                  >
                    {detail.value}
                  </Typography>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>

          {/* === Section: Order Items === */}
          <Typography variant="h6" sx={{ ...styles.remo_title_text, mt: 4 }}>
            <ShoppingCartIcon sx={{ color: "#5C5C5C" }} /> Order Items
          </Typography>
          <Divider sx={{ mb: 2, background: "#ABBBC2" }} />

          <Grid container spacing={1}>
            {approvalData?.orderItems?.map((item, idx) => (
              <React.Fragment key={idx}>
                <Grid item xs={6}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 500, color: "#5C5C5C" }}
                  >
                    {item.MENUNAME || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 600, textAlign: "right" }}
                  >
                    {currencyFormat(item.AMOUNT || "N/A")}
                  </Typography>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>

          {/* === Section: Agent Charges === */}
          <Typography variant="h6" sx={{ ...styles.remo_title_text, mt: 4 }}>
            <WorkIcon sx={{ color: "#5C5C5C" }} /> Agent Charges
          </Typography>
          <Divider sx={{ mb: 2, background: "#ABBBC2" }} />

          
             <Grid container spacing={2}>
            {agentDetails.map((detail, idx) => (
              <React.Fragment key={idx}>
                <Grid item xs={6}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 500, color: "#5C5C5C" }}
                  >
                    {detail.label}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 600, textAlign: "right" }}
                  >
                    {detail.value}
                  </Typography>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
      

            <Typography variant="h6" sx={{ ...styles.remo_title_text, mt: 4 }}>
            <AccountBalanceWalletIcon sx={{ color: "#5C5C5C" }} /> Agent Expense Charges
          </Typography>
          <Divider sx={{ mb: 2, background: "#ABBBC2" }} />

            <Grid container spacing={1}>
            {approvalData?.AgentExpensedet?.map((item, idx) => (
              <React.Fragment key={idx}>
                <Grid item xs={6}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 500, color: "#5C5C5C" }}
                  >
                    {item.REMARK}
                  
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 600, textAlign: "right" }}
                  >
                    {currencyFormat(item.AMOUNT)}
                  </Typography>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
  <Grid container spacing={1} mt={1}>
          {agentExp.map((detail, idx) => (
              <React.Fragment key={idx}>
                <Grid item xs={6}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 500, color: "#5C5C5C" }}
                  >
                    {detail.label}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 600, textAlign: "right" }}
                  >
                    {detail.value}
                  </Typography>
                </Grid>
              </React.Fragment>
            ))}
</Grid>
          {/* === Section: Billing Summary === */}
          <Typography variant="h6" sx={{ ...styles.remo_title_text, mt: 4 }}>
            <LocalAtmIcon sx={{ color: "#5C5C5C" }} /> Billing Summary
          </Typography>
          <Divider sx={{ mb: 2, background: "#ABBBC2" }} />

          <Grid container spacing={2}>
            {billingDetails.map((detail, idx) => (
              <React.Fragment key={idx}>
                <Grid item xs={6}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 500, color: "#5C5C5C" }}
                  >
                    {detail.label}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: 600, textAlign: "right" }}
                  >
                    {detail.value}
                  </Typography>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>

          {/* === Section: Actions === */}
          <Divider
            sx={{
              my: 3,

              background: "#ABBBC2",
            }}
          />

          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            flexWrap="wrap"
          >
            <Button
              variant="contained"
              // color="success"
              startIcon={<CheckCircle />}
              onClick={handleApprove}
              sx={{
                // ...styles.btn_primary,
                width: "100%",
                textAlign: "center",
                justifyContent: "center",
                textTransform: "capitalize",
                color: "#ffffff",
                textWrap: "nowrap",

                boxShadow: 1,
                minWidth: 140,
                background: "#00C851",

                // boxShadow: "0px 4px 10px rgba(0, 255, 128, 0.2)",
              }}
            >
              Approve
            </Button>

            {/* Uncomment if rejection is active */}
            {/* <Button
      variant="outlined"
      color="error"
      startIcon={<Cancel />}
      onClick={handleReject}
      sx={{
        minWidth: 140,
        borderWidth: 2,
      }}
    >
      Reject
    </Button> */}
          </Stack>
        </Paper>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={isApproved ? "success" : "error"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {successMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default RemoteApprovals;
